import Link from "next/link";
import type { AppLocale } from "@/i18n/config";

export default function SignupUnavailable({ locale }: { locale: AppLocale }) {
  const persian = locale === "fa";
  return (
    <div
      className="mx-auto max-w-lg px-6 py-16 text-center"
      dir={persian ? "rtl" : "ltr"}
    >
      <h1 className="text-xl font-semibold">
        {persian
          ? "ثبت‌نام موقتاً در دسترس نیست."
          : "Registration is temporarily unavailable."}
      </h1>
      <Link className="mt-6 inline-block underline" href={`/${locale}/signin`}>
        {persian ? "ورود به حساب کاربری" : "Sign in to your account"}
      </Link>
    </div>
  );
}
